import{jsx as t}from"react/jsx-runtime";import e from"styled-components";import{calculateRem as i}from"@vds-core/utilities";const a=e.img.withConfig({displayName:"StyledImg",componentId:"VDS__sc-1sspnel-0"})`
  object-fit: contain;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`,n=e.div.withConfig({displayName:"ImageWrapper",componentId:"VDS__sc-1sspnel-1"})`
  max-width: ${function({$maxWidth:t}){return t}}px;
  height: ${function({$maxHeight:t}){return t}}px;
  width: 100%;
  overflow: hidden;
  border-radius: ${i(4)};
  display: flex;
`,r=function(e){const{size:i,src:r,alt:o,ariaLabel:s}=e;return t(n,{$maxWidth:i,$maxHeight:i,children:t(a,{src:r,alt:o,"aria-label":s})})};r.defaultProps={size:"72"},r.displayName="ListGroupItemImage";export{r as default};
